import getAccountManagerInfo from "@hardware/Store/Handlers/MyAccount/GetAccountManager";
import { mediaQueriesBP } from "@hardware/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BinsPageContext } from "@insite/content-library/Pages/VmiBinsPage";
import Img, { ImgProps } from "@insite/mobius/Img";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        billtoId: state.context.session.billToId,
    };
};

const mapDispatchToProps = {
    getAccountManagerInfo,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface VmiDashboardCustomerLogoStyles {
    wrapper?: InjectableCss;
    img?: ImgProps;
}

export const customerLogoStyles: VmiDashboardCustomerLogoStyles = {
    wrapper: {
        css: css`
            max-width: 260px;
            padding: 10px;
            ${mediaQueriesBP.minMD} {
                margin-left: auto;
            }
        `,
    },

    img: {
        css: css`
            width: 100%;
            height: auto;
        `,
    },
};

const styles = customerLogoStyles;

const VmiDashboardCustomerLogo = ({ getAccountManagerInfo, billtoId }: Props) => {
    const [accountManagerInfo, setAccountManagerInfo] = useState({}) as any;

    useEffect(() => {
        if (!billtoId) {
            return;
        }

        getAccountManagerInfo({
            customerId: billtoId || "",
            onSuccess: () => {},
            onComplete: result => {
                if (result.apiResult) {
                    setAccountManagerInfo(result.apiResult.SalesPerson);
                }
            },
        });
    }, [billtoId]);

    if (!accountManagerInfo.CustomerLogoImagePath) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Img {...styles.img} src={accountManagerInfo.CustomerLogoImagePath} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(VmiDashboardCustomerLogo)),
    definition: {
        displayName: "VMI Customer Logo",
        group: "VMI Dashboard",
        allowedContexts: ["VmiDashboardPage", "VmiLocationsPage", BinsPageContext, "VmiReportingPage"],
    },
};

export default widgetModule;
